const plansData = {
  family2: [
    {
      name: "AMC Plan 1",
      price: "999",
      features: [
        "Includes Service",
        "Filter (Not Covered)",
        "Membrane (Not Covered)",
        "Electrical Parts (Not Covered)",
        "Faulty Parts (Not Covered)"
      ]
    },
    {
      name: "AMC Plan 2",
      price: "2500",
      gold: true,
      features: [
        "Includes Service",
        "Electrical Parts Covered",
        "Filter (Not Covered)",
        "Membrane (Not Covered)",
        "Faulty Parts (Not Covered)"
      ]
    },
    {
      name: "AMC Plan 3",
      price: "2450",
      features: [
        "Includes Service",
        "Filter Covered",
        "Electrical Parts (Not Covered)",
        "Membrane (Not Covered)",
        "Faulty Parts (Not Covered)"
      ]
    }
  ],

  family3: [
    {
      name: "AMC Plan 4",
      price: "6000",
      features: [
        "Includes Service",
        "Filter Covered",
        "Membrane Covered",
        "Electrical Parts (Not Covered)",
        "Faulty Parts (Not Covered)"
      ]
    },
    {
      name: "AMC Plan 5",
      price: "7500",
      gold: true,
      features: [
        "Includes Service",
        "Electrical Parts Covered",
        "Filter Covered",
        "Membrane Covered",
        "Faulty Parts (Not Covered)"
      ]
    },
    {
      name: "AMC Plan 6",
      price: "8500",
      features: [
        "Includes Service",
        "Filter Covered",
        "Electrical Parts Covered",
        "Membrane Covered",
        "Faulty Parts Covered"
      ]
    }
  ]
};

export default plansData;